import { render, staticRenderFns } from "./result-wishlist.vue?vue&type=template&id=292fa53f&"
import script from "./result-wishlist.vue?vue&type=script&lang=ts&"
export * from "./result-wishlist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports